<ng-container *transloco="let t">
  <header class="main-header">
    <div
      class="header-container"
      [class.header-container-collapsed]="desktopSidebarCollapsed()"
    >
      <div class="header-left">
        <button
          class="mobile-sidebar-btn"
          type="button"
          (click)="toggleMobileSidebar()"
          [attr.aria-label]="t('layout.header.menu')"
        >
          <i class="fas fa-bars"></i>
        </button>

        @if (desktopSidebarCollapsed()) {
        <button
          class="desktop-sidebar-btn icon-btn"
          type="button"
          (click)="toggleDesktopSidebar()"
          [attr.aria-label]="t('layout.sidebar.expand')"
        >
          <i class="fas fa-bars"></i>
        </button>
        }

        <a routerLink="/dashboard" class="mobile-logo-link">
          <img
            src="/assets/logo-light.png"
            [alt]="t('layout.header.logoAlt')"
            class="mobile-logo"
          />
        </a>
      </div>

      <form class="header-search" (ngSubmit)="submitSearch()">
        <i class="fas fa-search search-input-icon"></i>
        <input
          type="text"
          class="header-search-input"
          name="headerSearch"
          [(ngModel)]="searchQuery"
          [placeholder]="t('layout.header.searchPlaceholder')"
          [attr.aria-label]="t('layout.header.search')"
        />
        <button
          type="button"
          class="header-search-voice"
          tabindex="-1"
          aria-hidden="true"
        >
          <i class="fas fa-microphone"></i>
        </button>
      </form>

      <div class="header-actions">
        <div class="dropdown">
          <button
            class="icon-btn notification-btn dropdown-toggle"
            type="button"
            id="notificationMenuBtn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [attr.aria-label]="t('layout.header.notifications')"
          >
            <i class="fas fa-bell"></i>
            @if (notificationCount() > 0) {
            <span class="notification-badge">{{ notificationCount() }}</span>
            }
          </button>

          <ul
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="notificationMenuBtn"
          >
            <li class="dropdown-header">
              {{ t('layout.header.notifications') }}
            </li>
            <li>
              <a
                class="dropdown-item"
                [routerLink]="['/coming-soon', 'notifications']"
              >
                <i class="fas fa-circle-info"></i
                >{{ t('layout.header.newUpdates') }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                [routerLink]="['/coming-soon', 'notifications']"
              >
                <i class="fas fa-book-open-reader"></i
                >{{ t('layout.header.readingReminder') }}
              </a>
            </li>
          </ul>
        </div>

        <span class="header-divider"></span>

        <div
          class="activity-pill"
          [attr.aria-label]="t('layout.header.activity')"
        >
          <i class="fas fa-fire"></i>
          <span>{{ streakCount() }}</span>
        </div>

        <button
          class="icon-btn theme-toggle-btn"
          type="button"
          (click)="toggleDarkMode()"
          [attr.aria-label]="t('layout.header.toggleDarkMode')"
          [attr.title]="t('layout.header.toggleDarkMode')"
        >
          <i [class]="isDarkMode() ? 'fas fa-sun' : 'fas fa-moon'"></i>
        </button>

        <span class="header-divider"></span>

        @if (isAuthenticated()) {
        <div class="dropdown">
          <button
            class="user-btn dropdown-toggle"
            id="userMenuBtn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div class="user-avatar">
              <img
                class="user-avatar-image"
                [src]="userAvatarSrc()"
                alt="User avatar"
              />
            </div>
            <span class="d-none d-md-inline">{{ firstName() }}</span>
          </button>

          <ul
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="userMenuBtn"
          >
            <li>
              <a
                class="dropdown-item"
                [routerLink]="['/profile']"
              >
                <i class="fas fa-user"></i>{{ t('layout.header.profile') }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                [routerLink]="['/settings']"
              >
                <i class="fas fa-cog"></i>{{ t('layout.header.settings') }}
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                [routerLink]="['/coming-soon', 'subscription']"
              >
                <i class="fas fa-bookmark"></i
                >{{ t('layout.header.subscription') }}
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button type="button" class="dropdown-item" (click)="logout()">
                <i class="fas fa-sign-out-alt"></i
                >{{ t('layout.header.signOut') }}
              </button>
            </li>
          </ul>
        </div>
        } @else {
        <div class="dropdown">
          <button
            class="user-btn dropdown-toggle"
            id="guestMenuBtn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div class="user-avatar">
              <img
                class="user-avatar-image"
                [src]="userAvatarSrc()"
                alt="User avatar"
              />
            </div>
            <span class="d-none d-md-inline">{{
              t('layout.header.guest')
            }}</span>
          </button>

          <ul
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="guestMenuBtn"
          >
            <li>
              <a class="dropdown-item" routerLink="/auth/login">
                <i class="fas fa-sign-in-alt"></i>{{ t('auth.login') }}
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/auth/register">
                <i class="fas fa-user-plus"></i>{{ t('auth.register') }}
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/auth/reset-password">
                <i class="fas fa-key"></i>{{ t('auth.resetPassword') }}
              </a>
            </li>
          </ul>
        </div>
        }
      </div>
    </div>
  </header>
</ng-container>
